import styled from 'styled-components'

import { Item, ItemLabel, ItemValue } from '../_styles'
import { useProduct } from '../../../_methods'
import { useTranslation } from 'react-i18next'
import { getWineGrapeVarietiesStrings } from 'utils/wine'

const GrapesList = styled.div`
  display: flex;
  flex-direction: column;
`

const Grapes = () => {
  const { t } = useTranslation()
  const product = useProduct()

  const lines = getWineGrapeVarietiesStrings(product?.wine)

  if (!lines.length) return null

  return (
    <Item>
      <ItemLabel>{t('wine.view.grapes')}</ItemLabel>
      <GrapesList>
        {lines.map((line, idx) => (
          <ItemValue key={idx}>{line}</ItemValue>
        ))}
      </GrapesList>
    </Item>
  )
}

export default Grapes
